export enum UGCType {
  Dub = 1,
  Story = 2,
  Painting = 3,
  Coloring = 4,
  Gallery = 5,
  Dubsmash = 6
}

export type FileType =
  | "Dub"
  | "Story"
  | "Painting"
  | "Coloring"
  | "Gallery"
  | "Dubsmash";

export type FileLevel =
  | "HasUserAvatar"
  | "HasMediaFeatureAvatar"
  | "HasImage"
  | "Unknown";
